import axios from 'axios';
import { getHeaders } from './utils';
import { AULA_ASSIGNMENTS } from '../../constants/endpoints';

const create = (accessToken, spaceId, assignment) =>
  axios.post(
    `${AULA_ASSIGNMENTS()}`,
    {
      classId: spaceId,
      ...assignment,
    },
    {
      withCredentials: true,
      headers: getHeaders(accessToken),
    }
  );

export default create;
